<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>confirmation.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="main">
        <p class="vox-paragraph" [innerHTML]="message | translate: params"></p>
        <form [formGroup]="form">
          <div class="vox-input-group vox-input-group">
            <input class="vox-text-field"
              type="text"
              formControlName="alphaname"/><i
              class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
          </div>
        </form>
      </div>
      <div class="buttons-container">
        <button type="button" class="vox-btn vox-btn-secondary-dark-grey" (click)="close()" translate>confirmation.cancel</button>
        <button type="button" class="vox-btn vox-btn-secondary" [disabled]="form.invalid" (click)="ok()" translate>confirmation.ok</button>
      </div>
    </div>
  </div>
</div>
